import React, { useState } from 'react';
import { Button, Container, FormControl, FormLabel, Input, Stack, Typography } from '@mui/joy';
import { useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';

const Signup = () => {
    const { signUp } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await signUp(email, password);
            navigate('/confirm', { state: { email } });
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Sign up failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography level="h2" mb={2}>
                Create Account
            </Typography>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <FormControl>
                        <FormLabel>Email</FormLabel>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Password</FormLabel>
                        <Input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </FormControl>
                    {error && (
                        <Typography color="danger" level="body-sm">
                            {error}
                        </Typography>
                    )}
                    <Button type="submit" loading={loading}>
                        Sign Up
                    </Button>
                    <Button variant="plain" onClick={() => navigate('/login')}>
                        Already have an account? Log in
                    </Button>
                </Stack>
            </form>
        </Container>
    );
};

export default Signup;
